import redemptionService from './redemption.service';
import { initialState, RedemptionStatus } from './redemption.reducer';

import {
    SET_REDEEM_DATA,
    RECYCLE_REDEMPTION_PROCESS,
    SET_REDEMPTION_STATUS_FETCHING,
    REMOVE_REDEMPTION_STATUS,
    SET_REDEMPTION_CODE,
    SET_REDEMPTION_PLATFORM_TYPE,
    SET_REDEMPTION_STATUS
} from './redemption.constants';

import { IRedeemCodeData } from 'types/redemption';
import { Dispatch } from 'types/dispatch';
import { WIDGET_NAME } from '@sitegen/common/constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const saveRedeemCode = (code: string) => ({
    type: SET_REDEMPTION_CODE,
    payload: code
});

export const removeRedemptionStatus = () => ({
    type: REMOVE_REDEMPTION_STATUS
});

export const setFetching = (payload: boolean) => ({
    type: SET_REDEMPTION_STATUS_FETCHING,
    payload
});

export const setRedemptionStatus = (payload: RedemptionStatus) => ({
    type: SET_REDEMPTION_STATUS,
    payload
});

export const savePlatformType = (payload: PLATFORM_TYPES) => ({
    type: SET_REDEMPTION_PLATFORM_TYPE,
    payload
});

const setRedeemData = (payload: IRedeemCodeData) => ({
    type: SET_REDEEM_DATA,
    payload
});

export const redeemGift = (redeemData: IRedeemCodeData) => async (
    dispatch: Dispatch, getState: Function
): Promise<void> => {
    const state = getState();
    const ticket = state.login.loginSession.UbisoftConnectTicket;
    const sessionId = state.login.loginSession.sessionId;
    const applicationId = state.config.applicationId;

    dispatch(setFetching(true));

    dispatch(setRedeemData(redeemData));

    const redemptionStatus: RedemptionStatus = await redemptionService.redeemGift({
        redeemData,
        redeemConfigParams: {
            ticket,
            applicationId,
            sessionId
        },
        envName: state.config.envName
    });

    dispatch(setRedemptionStatus(redemptionStatus));
};

export const submitCode = (code: string) => async (
    dispatch: Dispatch,
    getState: Function
) => {
    const state = getState();
    const ticket = state.login.loginSession.UbisoftConnectTicket;
    const sessionId = state.login.loginSession.sessionId;
    const applicationId = state.config.applicationId;

    dispatch(setFetching(true));

    const redemptionStatus: RedemptionStatus = await redemptionService.submitCode({
        code,
        redeemConfigParams: {
            ticket,
            applicationId,
            sessionId
        },
        envName: state.config.envName
    });

    dispatch(setRedemptionStatus(redemptionStatus));
};

export const recycleRedemptionProcess = () => (dispatch: Dispatch, getState: Function) => {
    const state = getState();
    const selectedPlatform = state.redemption.redeemData.platform;
    const isWidgetPlatformFirstRedeem: boolean = state.config.widgetName === WIDGET_NAME.ULC_REDEEM;

    if (!selectedPlatform && isWidgetPlatformFirstRedeem) {
        return;
    }

    dispatch(removeRedemptionStatus());
    if (isWidgetPlatformFirstRedeem) {
        dispatch(setRedeemData({
            ...initialState.redeemData,
            platform: selectedPlatform
        }));
    }

    dispatch({ type: RECYCLE_REDEMPTION_PROCESS });
};

export type RedemptionActions = ReturnType<typeof setFetching>
| ReturnType<typeof saveRedeemCode>
| ReturnType<typeof removeRedemptionStatus>
| ReturnType<typeof setRedemptionStatus>
| ReturnType<typeof savePlatformType>
| ReturnType<typeof setRedeemData>;
